export default [
  {
    path: "/qe",
    children: [
        //students
      {
        path: "students",
        name: "qe-students",
        component: () =>
          import("@/views/qe/students/index.vue"),
        meta: {
          title: "QE STUDENTS",
          authRequired: true,
          acc: 'y13985'
        },
      },
        //students
      {
        path: "qe-studentslsi",
        name: "qeStudentsList",
        component: () => import("@/views/qe/students/list.vue"),
        meta: {
          title: "QE Students list",
          authRequired: true,
          acc: 'y54282'
        },
      },
      {
        path: "view-student/:id?",
        name: "qeStudent",
        component: () =>
          import("@/views/qe/students/view.vue"),
        meta: {
          title: "QE VIEW STUDENT",
          authRequired: true,
          acc: 'y37962'
        },
      },
      {
        path: "edit-student",
        name: "qe-edit-student",
        component: () =>
          import(
            "@/views/qe/students/components/edit.vue"
          ),
        meta: {
          title: "EDIT STUDENT",
        },
      },
      //register
      {
        path: "register",
        name: "qe-register",
        component: () =>
          import("@/views/qe/register.vue"),
        meta: {
          title: "REGISTER",
        },
      },
      //Cas
      {
        path: "cas",
        name: "qe-cas",
        component: () =>
          import("@/views/qe/cas/index.vue"),
        meta: {
          title: "CAS",
          authRequired: true,
          acc: 'y37962'
        },
      },
      {
        path: "withca/:id?",
        name: "qeWithCas",
        component: () =>
          import("@/views/qe/cas/withca.vue"),
        meta: {
          title: "QE With C.A",
          authRequired: true,
          acc: 'y37962'
        },
      },
      {
        path: "nonreg/:id?",
        name: "qeWithoutCas",
        component: () =>
          import("@/views/qe/cas/withoutca.vue"),
        meta: {
          title: "QE NON REG CAS",
          authRequired: true,
          acc: 'y37962'
        },
      },
      {
        path: "editca/:id?",
        name: "qe-editca",
        component: () =>
          import("@/views/qe/cas/edit.vue"),
        meta: {
          title: "UPDATE CA",
          authRequired: true,
          acc: 'y37962'
        },
      },
      //photo album
      {
        path: "photo_album",
        name: "qe-photo_album",
        component: () =>
          import("@/views/qe/photo-album.vue"),
        meta: {
          title: "PHOTO ALBUM",
        },
      },
      //gazette
      {
        path: "gazette",
        name: "qe-gazette",
        component: () =>
          import("@/views/qe/gazette/index.vue"),
        meta: {
          title: "GAZETTE",
        },
      },
      //exam card
      {
        path: "exam_card",
        name: "qeStudentsExamcard",
        component: () => import("@/views/qe/examcard.vue"),
        meta: {
          title: "QE EXAM CARD",
          authRequired: true,
          acc: 'y54282'

        },
      },
      //subject Analysis
      {
        path: "subject-analysis",
        name: "qe-subject-analysis",
        component: () =>
          import("@/views/qe/subject-analysis.vue"),
        meta: {
          title: "SUBJECT ANALYSIS",
        },
      },
    ],
  },
];
